/**
 *
 * IncompleteTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ActiveIcon from 'assets/v2/ActiveIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.tomatoDark};
    background: ${COLORS.tomatoLight};
    border-color: ${COLORS.tomato};
    border-radius: ${({ $borderRadius, theme }) => $borderRadius || theme.borderRadius.secondary};;

    &&& .MuiChip-icon path {
      fill: ${COLORS.tomato};
    }
  }
`;

function IncompleteTag(props) {
  return <StyledTag label="Incomplete" icon={<ActiveIcon />} {...props} />;
}

export default memo(IncompleteTag);
